/** Canonical patient gender codes, as the gender selects use them. "D" = divers / keine Angabe:
 *  divers, unbestimmt and unbekannt are one value (2026-10-19, same as backend utils/gender.ts —
 *  gender only decides the salutation, and none of the three gets Herr/Frau). */
export type GenderCode = "M" | "F" | "D";

/** Patient.gender is stored in more than one convention: "M"/"F"/"D" (patient page, new-patient
 *  dialog, GDT import), "W" for female (CSV import and the recipient page before 2026-10-19), and
 *  lowercase "m"/"w"/"u" (PAD import). A select only shows a value it has an option for, so a form
 *  maps whatever is stored onto the canonical code first — otherwise a GDT patient ("F") showed an
 *  empty gender on the recipient page. Anything else ("u", "0", "", missing) is "D". */
export function normalizeGenderCode(raw: unknown): GenderCode {
    const g = String(raw ?? "").trim().toLowerCase();
    if (g === "m" || g === "1" || g === "male" || g === "männlich") return "M";
    if (g === "f" || g === "w" || g === "2" || g === "female" || g === "weiblich") return "F";
    return "D";
}
